export default __webpack_public_path__ + "static/media/4-Cloudxier-Heavenlyblush-website-recipepage.e6732290.jpg";